module.exports = __webpack_public_path__ + "static/media/uk.bc48afcc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/flag/uk.svg
// module id = 547
// module chunks = 121